var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"search"}},[_c('h2',{staticClass:"title is-2"},[_vm._v("Search results for: "+_vm._s(_vm.searchTerm))]),_c('search-form',{attrs:{"defaultTerm":_vm.searchTerm}}),_c('list-posts',{attrs:{"posts":_vm.posts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }